<template>
  <!-- 登录密码过期强制修改弹窗（隐藏取消与关闭按钮） -->
  <update-pass ref="passDialog" forced />
</template>

<script>
import { mapGetters } from 'vuex'
import UpdatePass from '@/views/system/user/center/UpdatePass.vue'
import { checkPwdExpire } from '@/api/system/user'

export default {
  name: 'PwdExpiredDialog',
  components: {
    UpdatePass
  },
  computed: {
    ...mapGetters(['token', 'pwdExpired']),
    // 登录页（含登录时选择企业的阶段）不弹窗，避免遮挡“选择公司”弹窗
    canShow() {
      return !!this.token && this.$route.path !== '/login'
    }
  },
  watch: {
    // 进入业务页面后立即检查密码是否过期（登录时需先选完企业再检查）
    canShow: {
      handler(val) {
        if (!val) return
        // 已收到 533 直接弹出，否则主动检查一次
        if (this.pwdExpired) {
          this.openDialog()
        } else {
          this.checkExpire()
        }
      },
      immediate: true
    },
    // 接口返回 533 时由 request 拦截器置位
    pwdExpired(val) {
      if (val && this.canShow) {
        this.openDialog()
      }
    }
  },
  methods: {
    // 打开弹窗，已打开时不重复打开
    openDialog() {
      this.$nextTick(() => {
        if (this.$refs.passDialog) {
          this.$refs.passDialog.open()
        }
      })
    },
    checkExpire() {
      if (this.pwdExpired) {
        this.openDialog()
        return
      }
      // 校验期间置为 pending，让协议弹窗等全局弹窗先让位，校验结束后再决定
      this.$store.commit('SET_PWD_EXPIRED_PENDING', true)
      const finishCheck = () => this.$store.commit('SET_PWD_EXPIRED_PENDING', false)
      checkPwdExpire().then(expired => {
        if (expired === true) {
          // 与 533 拦截保持同一状态口径，供其它全局弹窗判断优先级
          if (!this.pwdExpired) {
            this.$store.commit('SET_PWD_EXPIRED', true)
          }
          this.openDialog()
        }
      }).catch(() => {}).then(finishCheck)
    }
  }
}
</script>
